<boi-contextual-help-container [ngClass]="{'has-errors': hasError}"
    [contextualHelpName]="contextualHelpName !== undefined ? contextualHelpName : labelName">
    <boi-validation-error (errorChange)="hasError=$event" [propertyNames]="propertyNames"></boi-validation-error>
    <kendo-textbox-container class="form-element app">
        <div class="form-label app" [boiRequiredFormField]="labelName">
            <label [for]="controlId ? controlId : labelName" [innerHtml]="labelName |
                        localizeLabel"></label>
        </div>
        <div class="form-input-container term-input-container">

            <kendo-numerictextbox [ngClass]="{'disabled': isFieldDisabled}" [disabled]="isFieldDisabled"
                [id]="controlId ? controlId : labelName" spinners="false" [(ngModel)]="years" [min]="0" [max]="99" [step]="0"
                [format]="'n'" (ngModelChange)="yearsChange.emit(years)" [autoCorrect]="true" decimals="0"
                [title]="tooltipName ? (tooltipName | localizeTooltip) : (labelName | localizeTooltip)">
            </kendo-numerictextbox>
            <label class="term-input-label ml-10 mr-10">{{referenceDataLabels.YearsId | localizeLabel}}</label>

            <kendo-numerictextbox [ngClass]="{'disabled': isFieldDisabled}" [disabled]="isFieldDisabled"
                spinners="false" [(ngModel)]="months" [min]="0" [max]="11" [format]="'n'" decimals="0"
                (ngModelChange)="monthsChange.emit(months)" [autoCorrect]="true" [step]="0"
                [title]="tooltipName ? (tooltipName | localizeTooltip) : (labelName | localizeTooltip)">
            </kendo-numerictextbox>
            <label class="term-input-label mr-10 ml-10">{{referenceDataLabels.MonthsId | localizeLabel}}</label>
        </div>

        <boi-tooltip [tooltipName]="tooltipName ? tooltipName : labelName"></boi-tooltip>
        
    </kendo-textbox-container>
</boi-contextual-help-container>